/**
 * Flow-canvas slice of the English catalog.
 *
 * en.ts sits close to the 500-line fileSize ceiling, so canvas copy lives
 * here and is spread back into `en` in en.ts — t() and MessageKey unchanged.
 * Add new palette.* / canvas.* keys HERE.
 */
export const enCanvas = {
  // ── Step palette ──────────────────────────────────────────────────────
  'palette.search': 'Search steps',
  'palette.searchClear': 'Clear search',
  'palette.noResults': 'No steps match “{query}”.',

  // ── Empty canvas ──────────────────────────────────────────────────────
  'canvas.emptyTitle': 'This flow has no steps yet',
  'canvas.emptyBody': 'Add the first step, or drag one in from the palette.',
  'canvas.emptyCta': 'Add first step',

  // ── My Automations → chat flows (WhatsApp / Instagram / Messenger) ────
  'chatFlows.title': 'Chat flows',
  'chatFlows.default': 'Default',
  'chatFlows.runs': '{count} runs',
  'chatFlows.statusLive': 'Live',
  'chatFlows.statusPaused': 'Paused',
  'chatFlows.statusDraft': 'Draft',
  'chatFlows.activate': 'Activate',
  'chatFlows.pause': 'Pause',
  'chatFlows.open': 'Open in canvas',
  'chatFlows.toggleFailed': 'Could not change this chat flow',
  'chatFlows.reset': 'Reset to factory',
  'chatFlows.resetConfirm': 'Replace the Default Flow with the current factory version? Edits you made to it are lost.',
  'chatFlows.resetDone': 'Default Flow reset to factory',
  'chatFlows.resetFailed': 'Could not reset the Default Flow',

  // ── Email step body editor (Blocks | HTML) ───────────────────────────
  'emailBuilder.htmlAuthoredTitle': 'This email was written as HTML',
  'emailBuilder.htmlAuthoredBody': 'Its body lives in the HTML tab, and that is what your customers receive. Edit it there — the block layout is only for emails built with blocks.',
  'emailBuilder.htmlAuthoredCta': 'Edit the HTML',

  // ── My Automations / Studio navigation (DOGFOOD-SUPPORT item 18) ─────
  'workflow.defaultName': 'New workflow – {stamp}',
  'studio.tab.campaigns': 'Campaigns',
  'flows.emailTitle': 'Email flows',
  'flows.searchPlaceholder': 'Search flows…',
  'flows.statusFiltersAria': 'Filter email flows by status',
  'workflows.details': 'Details',

  // ── Studio / Automations Lab page headers ────────────────────────────
  'studio.title': 'Automations',
  'studio.subtitle':
    'Email, chat, and popups — triggers, flows, and conversations in one place.',
  'studio.canvas.subtitle':
    'Wire any API to any action — drag nodes, map JSON, run it.',
  'lab.subtitle':
    'Connect anything to anything. Rules run — no AI at runtime.',

  // ── Per-step counters on the flow canvas (V63) ───────────────────────
  'flowStats.sent': '{count} sent',
  'flowStats.open': '{rate}% open',
  'flowStats.click': '{rate}% click',
  'flowStats.untracked': '{count} earlier events were recorded before per-step tracking. They count in this flow’s totals, not on a step.',

  // ── Test sends — always to the workspace owner (V63) ─────────────────
  'flowTest.button': 'Test',
  'flowTest.sending': 'Sending…',
  'flowTest.sendsTo': 'Sends every email step to you: {email}',
  'flowTest.sendsToOwner': 'Sends every email step to the workspace owner',
  'flowTest.sent': 'Test sent to {email} — {count} email(s). Test sends are not counted in this flow\'s stats.',
  'flowTest.partial': '{sent} sent, {failed} not sent to {email}: {error}',
  'flowTest.failed': 'Test not sent: {error}',
  'flowTest.saveFirst': 'Could not save the flow, so no test was sent. Fix the error and try again.',
  'flowTest.saveLiveFirst': 'This flow is live. Save your changes first, then send a test.',
  'flowTest.simulate': 'Simulate',
  'flowTest.simulateTitle': 'Dry run with a sample contact — nothing is sent',
  'flowTest.stepLabel': 'Send test to me',
  'flowTest.stepButton': 'Send test',
  'flowTest.stepHint': 'Saves the flow, then sends this step to you: {email}.',
  'flowTest.stepHintOwner': 'Saves the flow, then sends this step to the workspace owner.',
  'flowTest.noSubject': 'Add a subject first.',

  // ── Email flow status: back to Draft (list + builder) ────────────────
  'emailFlow.setDraft': 'Set to draft',
  'emailFlow.setDraftNamed': 'Set {name} to draft',
  'emailFlow.setDraftHint': 'Stop this flow and move it back to Draft',
  'emailFlow.setDraftDone': 'Flow moved to Draft',
  'emailFlow.setDraftFailed': 'Could not move this flow to Draft. Try again.',

  // ── Business action nodes (board picker) ─────────────────────────────
  'canvas.business.noBoards': 'No boards found',
  'canvas.business.createBoardFirst': 'Create a board first before adding a "Create board row" action.',
  'canvas.business.createBoardLink': 'Create a board',
  'canvas.business.boardLabel': 'Board',
  'canvas.business.selectBoard': 'Select a board…',
  'canvas.business.selectBoardRequired': 'A board must be selected before saving.',
  'canvas.business.loadingBoards': 'Loading boards...',
  'canvas.business.boardId': 'ID: {id}',
} as const;
